import { client } from "@lib/api"
import useSWR from "swr"

type BankTransferPaymentFee = {
    fee: string,
    ui_fee: number
}

const useBankTransferPaymentFee = () => {
    const { data, error, isLoading } = useSWR('/v2/wallet/pay/bank_transfer/fee', client.doGet)
    return {
        data: data as BankTransferPaymentFee,
        error,
        isLoading
    }
}

export default useBankTransferPaymentFee
